import React from 'react';
import './typeahead.scss';
import ItemList from './itemList';
import loadingImg from '../../assets/images/loading.gif'

const KeyDownArrow = 40;
const KeyUpArrow = 38;
const KeyEnter = 13;

const initialState = {
    currentFocus: 0,
    itens: [],
    value: "",
    id: "",
    isFocus: false,
    isMouse: false,
    className: ""
}

const fieldValidationMessage = {
    'valueMissing': () => 'Este campo é obrigatório.',
    'tooShort': value => `Este campo deve ter no mínimo ${value.validations.minlength} caracteres.`,
    'tooLong': value => `Este campo deve ter no máximo ${value.validations.maxlength} caracteres.`,
    'typeMismatch': value => `${value.label} inválido!`,
}

class Typeahead extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = { ...initialState };
        this.setActive = this.setActive.bind(this);

        this.handleChange = this.handleChange.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleFocus = this.handleFocus.bind(this)
        this.handleClick = this.handleClick.bind(this);
        this.handleMouseOver = this.handleMouseOver.bind(this);
        this.handleMouseOut = this.handleMouseOut.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;

        let { returnObject } = this.props;

        if (returnObject) {
            returnObject(this)
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentWillReceiveProps(nextProps) {

        let { value, dataSource, fieldValue, fieldText, loading } = nextProps;
        let newState = { ...this.state };

        if (value && !loading) {

            let indice = -1;
            let itens = [];
            let Id = "";
            for (let index = 0; index < dataSource.length; index++) {

                indice++;

                Id = dataSource[index][fieldValue]

                if ( Id === value) {

                    itens.push({
                        key: indice,
                        letter: "",
                        letters: "",
                        value: dataSource[index][fieldText],
                        id: dataSource[index][fieldValue],
                        active: false
                    });

                    break;
                } else {
                    indice--;
                }
            }

            newState.itens = itens;
            newState.value = itens[0].value;
            newState.id = itens[0].id;

            this.setState(newState);
        } else {

            newState.value = "";
            newState.id = "";
            this.setState(newState);
        }
    }

    render() {

        let { handleChange, handleClick, handleKeydown, handleBlur, handleFocus, handleMouseOver, handleMouseOut } = this;
        let { itens, isFocus, isMouse, value, className, errorDescription } = this.state;
        let { name, label, required, disabled, loading } = this.props;

        let hasValue = value ? 'has-value' : ''
        return (
            <>
                <label htmlFor={name} className={`typeahead autocomplete ${className} ${hasValue}`}>
                    <input
                        type="text"
                        placeholder="&nbsp;"
                        onChange={handleChange}
                        onKeyDown={handleKeydown}
                        required={required}
                        value={value}
                        onBlur={handleBlur}
                        onFocus={handleFocus}
                        id={name}
                        name={name}
                        valor={value}
                        disabled={disabled}
                        ref={input => { this.input = input }}
                    />
                    {loading && <i className="icon"> <img src={loadingImg} alt="loading" /></i>}
                    <span className="label">{label} {required ? "*" : ""}</span>
                    <span className="border"></span>
                    <small className="message">{errorDescription}</small>

                </label>
                {isFocus &&
                    <ItemList
                        className={"autocomplete-items"}
                        itens={itens}
                        onClick={handleClick}
                        onMouseOver={handleMouseOver}
                        onMouseOut={handleMouseOut}
                        isMouse={isMouse} />}
            </>
        );
    }


    handleFocus(event) {

        this.handleChange(event)
        this.setState({ isSave: true });
    }

    notifyValue() {

        let { id } = this.state;
        let { onChange, name } = this.props;

        onChange({ value: id, name });
    }

    handleKeydown(event) {

        let { currentFocus, itens } = this.state;

        if (event.keyCode === KeyDownArrow) {

            this.setActive(++currentFocus);

        } else if (event.keyCode === KeyUpArrow) {

            this.setActive(--currentFocus);

        } else if (event.keyCode === KeyEnter) {

            event.preventDefault();

            if (currentFocus > -1 && itens[currentFocus]) {
                this.setState({ value: itens[currentFocus].value, id: itens[currentFocus].id, isSave: false }, () => {
                    this.notifyValue();
                    this.validate(this.input);
                });
                this.createArrayItens();
            }

            this.setState({ isMouse: false, isFocus: false })
        }
    }

    createArrayItens() {

        let { currentFocus, itens } = this.state;
        let arrayItens = [];

        arrayItens.push({
            key: 0,
            letter: "",
            letters: "",
            value: itens[currentFocus].value,
            id: itens[currentFocus].id,
            active: false
        });

        this.setState({ itens: arrayItens, currentFocus: 0 })
    }

    setActive(focus) {

        let array = [];
        let { itens } = this.state;

        if (focus >= itens.length) {
            focus = 0;
        }

        if (focus < 0) {
            focus = itens.length - 1;
        }

        itens.forEach((element, indice) => {

            element.active = indice === focus;
            array.push(element);
        });

        this.setState({ itens: array, currentFocus: focus });
    }

    handleMouseOver(event, item, isMouse) {

        this.setActive(item.key)

        this.setState({ isMouse: isMouse, currentFocus: item.key })
    }

    handleMouseOut(event, item, isMouse) {

        this.setActive(item.key)

        this.setState({ isMouse: isMouse })
    }

    handleClick(event, item) {

        this.setState({ value: item.value, id: item.id, isFocus: false, isMouse: false }, () => {
            this.notifyValue();
            this.validate(this.input);
        });
    }


    async handleChange(event) {

        let value = event.target.value;
        let { dataSource, fieldValue, fieldText } = this.props;
        let itens = [];
        let indice = -1;

        this.setState({ value: value, isFocus: true });

        if (!value) {
            this.setState({ isFocus: false, currentFocus: -1, itens: [], id: "" }, () => this.notifyValue());
            return false;
        }

        for (let i = 0; i < dataSource.length; i++) {
            indice++;
            if (dataSource[i][fieldText].toUpperCase().indexOf(value.toUpperCase()) > -1) {
                itens.push({
                    key: indice,
                    letter: dataSource[i][fieldText].substr(0, value.length),
                    letters: dataSource[i][fieldText].substr(value.length),
                    value: dataSource[i][fieldText],
                    id: dataSource[i][fieldValue],
                    active: indice === 0
                });
            } else {
                indice--;
            }
        }

        this.setState({ itens: itens, currentFocus: 0, isSave: true });
    }

    handleBlur(event) {

        let { isMouse, currentFocus, itens, isSave } = this.state;

        if (!isMouse && itens[currentFocus]) {
            if (isSave) {
                this.setState({ isFocus: false, value: itens[currentFocus].value, id: itens[currentFocus].id }, () => {
                    this.notifyValue();
                    this.validate(this.input);
                });
                this.createArrayItens()                        
            }

        } else {
            this.validate(this.input)
        }

        this.setState({ isSave: true, className: 'validate' });      
    }

    validateSync = value => {
        if (!this.props.validateSync)
            return true

        return this.props.validateSync(value)
    }

    validatePropertiesValidityState = validityState => {
        for (var key in validityState) {
            if (validityState[key] === true && key !== 'valid')
                return key
        }

    }

    validate = field => {
        let fieldValidityState = null

        return new Promise((resolve, reject) => {

            // if(!this.state.id){
            //     reject({message: "Nenhum item foi selecionado!"})
            // }
            
            if (!field.checkValidity()) {
                fieldValidityState = field.validity

                let errorType = this.validatePropertiesValidityState(fieldValidityState)
                reject({ message: fieldValidationMessage[errorType]({ ...this.props, ...this.state }) })
            }       

            let resultValidateSync = this.validateSync(field.value)
            if (resultValidateSync !== true)
                reject(resultValidateSync)

            this.setState({ asyncLoading: true })
            resolve(field.value)
        })
            .then(this.validateAsync)
            .then(() => {
                this.setState({ className: 'info', errorDescription: '' })
                field.setCustomValidity('')
                return true
            })
            .catch(error => {
                this.setState({ className: 'danger', errorDescription: error.message })
                let { onError } = this.props
                if (onError)
                    onError({ name: this.state.name, errorDescription: error.message })

                return false
            }).finally(() => {
                this.setState({ asyncLoading: false })
                return this.state
            })
    }
}


export default Typeahead;


